<div class="table-card">
  <div class="table-card__filter">
    <ng-content></ng-content>
  </div>

  <div class="table-card__body">
    <table
      mat-table
      class="xemex-data-table min-w-full"
      [dataSource]="$any(loading() ? skeletonDataSource : dataSource)"
    >
      @if (selectable()) {
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="cell--center" style="width: 3rem">
            @if (loading()) {
              <xemex-skeleton-block
                width="20px"
                height="20px"
                borderRadius="4px"
              ></xemex-skeleton-block>
            } @else {
              <mat-checkbox
                [checked]="isAllSelected()"
                [indeterminate]="isIndeterminate()"
                (change)="toggleAll()"
              ></mat-checkbox>
            }
          </th>
          <td mat-cell *matCellDef="let row" class="cell--center" style="width: 3rem">
            @if (loading()) {
              <xemex-skeleton-block
                width="20px"
                height="20px"
                borderRadius="4px"
              ></xemex-skeleton-block>
            } @else {
              <mat-checkbox
                [checked]="isRowChecked(row)"
                [disabled]="isRowDisabled(row)"
                (change)="toggleRow(row)"
                (click)="$event.stopPropagation()"
              ></mat-checkbox>
            }
          </td>
        </ng-container>
      }

      @for (col of columns(); track col.field) {
        <ng-container [matColumnDef]="col.field" [sticky]="!!col.sticky">
          <th
            mat-header-cell
            *matHeaderCellDef
            [style.width]="col.width"
            [class.cell--center]="col.type === 'toggle'"
            [attr.title]="col.tooltip ?? null"
            [attr.aria-label]="col.tooltip ?? null"
          >
            @if (col.subLabel) {
              <span class="header-label">{{ col.label | translate }}</span>
              <span class="header-sub-label">{{ col.subLabel }}</span>
            } @else {
              {{ col.label | translate }}
            }
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            [style.width]="col.width"
            [class.font-bold]="col.bold"
            [class.cell--muted]="col.muted"
            [class.cell--center]="col.type === 'toggle'"
            [class.cell--accent]="!!col.accentColorMap"
            [style.--accent-color]="
              !loading() && col.accentColorMap
                ? col.accentColorMap['' + cellValue(row, col.accentField ?? col.field)]
                : null
            "
          >
            @switch (col.type) {
              @case ('date') {
                @if (loading()) {
                  <xemex-skeleton-block width="60%" height="16px"></xemex-skeleton-block>
                } @else {
                  {{
                    cellValue(row, col.field) != null
                      ? ($any(cellValue(row, col.field)) | date: 'mediumDate')
                      : '–'
                  }}
                }
              }
              @case ('tag') {
                @if (loading()) {
                  <xemex-skeleton-block
                    width="64px"
                    height="20px"
                    borderRadius="4px"
                  ></xemex-skeleton-block>
                } @else {
                  @if (cellValue(row, col.field) != null && cellValue(row, col.field) !== '') {
                    <xemex-tag
                      [state]="tagState(col, row)"
                      [label]="$any(cellValue(row, col.field))"
                    />
                  } @else if (!col.blankWhenEmpty) {
                    –
                  }
                }
              }
              @case ('select') {
                @if (loading()) {
                  <xemex-skeleton-block
                    width="64px"
                    height="20px"
                    borderRadius="4px"
                  ></xemex-skeleton-block>
                } @else if (isCellDisabled(col, row)) {
                  <xemex-tag
                    [state]="tagState(col, row)"
                    [label]="$any(cellValue(row, col.field))"
                  />
                } @else {
                  <button
                    type="button"
                    class="select-cell-trigger"
                    [matMenuTriggerFor]="selectMenu"
                    (click)="$event.stopPropagation()"
                  >
                    <xemex-tag
                      [state]="tagState(col, row)"
                      [label]="$any(cellValue(row, col.field))"
                    />
                  </button>
                  <mat-menu #selectMenu="matMenu">
                    @for (option of col.selectOptions; track option.value) {
                      <button mat-menu-item (click)="onSelectOption(col, row, option.value)">
                        <xemex-tag [state]="$any(option.state)" [label]="option.label" />
                      </button>
                    }
                  </mat-menu>
                }
              }
              @case ('colored-text') {
                @if (loading()) {
                  <xemex-skeleton-block width="60%" height="16px"></xemex-skeleton-block>
                } @else {
                  @if (cellValue(row, col.field) != null && cellValue(row, col.field) !== '') {
                    <span [style.color]="col.textColorMap?.['' + cellValue(row, col.field)]">
                      {{ cellValue(row, col.field) }}
                    </span>
                  } @else {
                    –
                  }
                }
              }
              @case ('toggle') {
                @if (loading()) {
                  <xemex-skeleton-block
                    width="36px"
                    height="20px"
                    borderRadius="10px"
                  ></xemex-skeleton-block>
                } @else {
                  <mat-slide-toggle
                    [checked]="!!cellValue(row, col.field)"
                    [disabled]="isCellDisabled(col, row)"
                    (click)="$event.stopPropagation()"
                    (change)="onToggleChange(col, row)"
                  ></mat-slide-toggle>
                }
              }
              @case ('link') {
                @if (loading()) {
                  <xemex-skeleton-block width="60%" height="16px"></xemex-skeleton-block>
                } @else {
                  @if (cellValue(row, col.field) != null && cellValue(row, col.field) !== '') {
                    @if (col.linkFn?.(row); as commands) {
                      <a
                        class="cell-link"
                        [routerLink]="commands"
                        (click)="$event.stopPropagation()"
                        >{{ cellValue(row, col.field) }}</a
                      >
                    } @else {
                      {{ cellValue(row, col.field) }}
                    }
                    @if (col.secondaryField && cellValue(row, col.secondaryField)) {
                      <span class="cell-secondary">
                        · {{ cellValue(row, col.secondaryField) }}</span
                      >
                    }
                  } @else {
                    –
                  }
                }
              }
              @default {
                @if (loading()) {
                  <xemex-skeleton-block width="60%" height="16px"></xemex-skeleton-block>
                } @else {
                  @if (col.iconField && cellValue(row, col.iconField)) {
                    <mat-icon
                      class="cell-icon"
                      aria-hidden="true"
                      [fontSet]="outlinedIcons() ? 'material-icons-outlined' : ''"
                      >{{ cellValue(row, col.iconField) }}</mat-icon
                    >
                  }
                  {{
                    cellValue(row, col.field) != null && cellValue(row, col.field) !== ''
                      ? cellValue(row, col.field)
                      : '–'
                  }}
                  @if (col.subtitleField && cellValue(row, col.subtitleField)) {
                    <div class="cell-subtitle">{{ cellValue(row, col.subtitleField) }}</div>
                  }
                }
              }
            }
          </td>
        </ng-container>
      }

      @if (actionsCellTpl) {
        <ng-container matColumnDef="actions">
          @let actionsLabelValue = actionsLabel();
          <th mat-header-cell *matHeaderCellDef [style.width]="actionsWidth()">
            {{ actionsLabelValue ? (actionsLabelValue | translate) : '' }}
          </th>
          <td mat-cell *matCellDef="let row" class="text-right" [style.width]="actionsWidth()">
            @if (!loading()) {
              <ng-container
                *ngTemplateOutlet="actionsCellTpl; context: { $implicit: row }"
              ></ng-container>
            }
          </td>
        </ng-container>
      }

      <ng-container matColumnDef="xemex-group-header">
        <td
          mat-cell
          *matCellDef="let group"
          class="table-group-cell"
          [attr.colspan]="allColumns().length"
        >
          <button
            type="button"
            class="table-group-toggle"
            [attr.aria-expanded]="group.expanded"
            (click)="toggleGroup(group.key)"
          >
            <mat-icon class="table-group-toggle__chevron">{{
              group.expanded ? 'expand_more' : 'chevron_right'
            }}</mat-icon>
            @if (group.icon) {
              <mat-icon
                class="table-group-toggle__icon"
                [fontSet]="outlinedIcons() ? 'material-icons-outlined' : ''"
                >{{ group.icon }}</mat-icon
              >
            }
            <span class="table-group-toggle__label">{{ group.label | translate }}</span>
            @if (showGroupCounts()) {
              <span class="table-group-toggle__count">{{ group.count }}</span>
            }
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="allColumns()"></tr>
      <tr
        mat-row
        class="table-group-row"
        *matRowDef="let row; columns: ['xemex-group-header']; when: isGroupHeader"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: allColumns()"
        [routerLink]="!loading() && rowLink() ? rowLink()!(row) : null"
        [class.cursor-pointer]="
          !loading() && !isRowDisabled(row) && (selectable() || !!rowLink() || clickableRows())
        "
        [class.table-row--disabled]="!loading() && isRowDisabled(row)"
        (click)="onRowClick(row)"
      ></tr>
      <tr class="mat-row" *matNoDataRow>
        @if (!loading()) {
          <td class="mat-cell py-6 text-center text-gray-500" [attr.colspan]="allColumns().length">
            @if (emptyStateTpl) {
              <ng-container *ngTemplateOutlet="emptyStateTpl" />
            } @else {
              {{ 'general.noData' | translate }}
            }
          </td>
        }
      </tr>
    </table>
  </div>

  @if (!groups() && showFooter()) {
    <xemex-table-pagination
      [page]="currentPage()"
      [totalPages]="totalPages()"
      [total]="effectiveTotalCount()"
      [pageSize]="pageSize()"
      [showControls]="pageable()"
      [compact]="compact()"
      (pageChange)="onPageChange($event)"
    ></xemex-table-pagination>
  }
</div>
